export const base = {
    "recent_test": "bt gần đây",
    "parts": "ds.bài học",
    "list_result": "ds kết quả",
    "result": "kết quả",
    "alert_submit": "Hoàn thành",
    "mid_test": "Kiểm tra",
    "final_test": "Kiểm tra",
    "survey_type": "Khảo sát",
    "vote_type": "Bình chọn",
    "learn_everywhere": "Học mọi lúc mọi nơi",
    "confirm": "Xác nhận",
    "question": "Câu",
    "continue_practice": "tiếp tục ôn tập",
    "continue_learning": "học lại",
    "retest": "THI LẠI",
    "practice_lesson": "học bài",
    "retake_test": "kiểm tra lại",
    "test": "kiểm tra",
    "practice": "Bài học",
    "exam": "thi",
    "submit": "Hoàn thành",
    "continue": "tiếp tục",
    "comeback": "quay lại",
    "yes": "Có",
    "no": "Không",
    "your_opinion": "Ý kiến khác",
    "back_lesson": "Quay lại",
    "correct_answer": "Câu trả lời chính xác",
    "user_name": "Tên học viên",
    "phone_number": "Số điện thoại",
};
